import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postThanetCouncilForms } from "../../redux/actions/thanetCouncilActions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const DVLACheckAndSignatureForm = ({ appData, postThanetCouncilFormsFunc }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className={"mb-2"}>
            I <b>{initialData.name}</b> hereby consent to HRGO Recruitment
            checking my driving licence by using the online checking service
            provided by the DVLA at any time during my period of service with HR
            GO Recruitment.
          </p>
          <p>
            As part of the procedure I agree that HRGO Recruitment may supply
            the DVLA with my postcode, National Insurance number, Driving
            Licence number and conduct licence checks.
          </p>
          <p>
            I understand that this consent will be terminated in the event that
            my service with HRGO Recruitment is terminated by either party.
          </p>
        </div>
      ),
    },
    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.thanetCouncilOnboarding &&
    appData.thanetCouncilOnboarding.dvlaCheckAndSignature;

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postThanetCouncilFormsFunc("dvlaCheckAndSignature", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    history.push("/profile/edit/thanet-council-onboarding");
  };

  const redirectBack = () => {
    history.push("/profile/edit/thanet-council-onboarding");
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"DVLA Check"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"thanetCouncil"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

DVLACheckAndSignatureForm.propTypes = {
  appData: any,
  postThanetCouncilFormsFunc: func,
};

const mapDispatchToProps = {
  postThanetCouncilFormsFunc: postThanetCouncilForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DVLACheckAndSignatureForm);
